



















































import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import BaseFilterBar from "../components/BaseFilterBar.vue";
import BaseDataLook from "./components/BaseDataLook.vue";
import { navList, titleLineList } from "./components/dataConfig";
import BaseEcharts from "./components/BaseEcharts.vue";
import BaseTable from "./components/BaseTable.vue";
import { marginDataAnalysisHead } from "@/req/dataIndex";
@Component({
  components: {
    headerTitle,
    BaseFilterBar,
    BaseDataLook,
    BaseEcharts,
    BaseTable,
  },
})
export default class Home extends Vue {
  public baseList = {
    date_type: 1,
    start_time: "",
    end_time: "",
    contrast: 0,
    contrast_start_time: "",
    contrast_end_time: "",
    game_id: "",
    device_type: "",
  };
  public nowData: any = [];
  public pastData: any = [];
  public navList: any = navList;
  public navActive = 0;
  public allList: any = {};
  public allLists: any = {};
  public nowList: any = [];
  public pastList: any = [];
  public typeId = "";
  public mounted() {
    this.getList();
  }
  public returnFilterList(list) {
    this.baseList = list;
    this.setTypeId();
    this.getList();
  }
  public setTypeId() {
    if (!this.navList[this.navActive].key && this.baseList.contrast == 1) {
      this.typeId = this.navList[this.navActive].list[0].key;
    } else {
      this.typeId = "";
    }
  }
  public addType(index) {
    this.navActive = index;
    this.setTypeId();
    this.getList();
  }
  public async getList() {
    const res = await marginDataAnalysisHead({
      ...this.baseList,
      type: this.navList[this.navActive].id,
    });
    if (res.code == 0) {
      this.nowData = [
        res.data.data.margin_total_re_amount,
        res.data.data.margin_balance_re_amount,
        res.data.data.margin_ali_re_amount,
        res.data.data.margin_total_ref_amount,
        res.data.data.margin_balance_ref_amount,
        res.data.data.margin_ali_ref_amount,
        res.data.data.margin_total_in_amount,
      ];
      this.allList = res.data.data.date_arr;
      const $BaseDataLook: any = this.$refs.BaseDataLook;
      if (this.baseList.contrast == 1) {
        this.pastData = [
          res.data.data.margin_total_re_amount,
          res.data.data.margin_balance_re_amount,
          res.data.data.margin_ali_re_amount,
          res.data.data.margin_total_ref_amount,
          res.data.data.margin_balance_ref_amount,
          res.data.data.margin_ali_ref_amount,
          res.data.data.margin_total_in_amount,
        ];
        this.allLists = res.data.data_contrast.date_arr;
        $BaseDataLook.parentList(this.nowData, true, this.pastData);
      } else {
        this.pastData = [];
        $BaseDataLook.parentList(this.nowData, false, []);
      }
      this.getEcharts();
    }
  }
  public typeChange() {
    this.getEcharts();
  }
  public getEcharts() {
    const titleList: any = [];
    const titleLists: any = [];
    let dateList: any = [];
    let pastDateList: any = [];
    const seriesList: any = [];
    if (this.baseList.contrast == 0) {
      for (const key of Object.keys(this.allList)) {
        titleList.push(this.returnLineTitle(key));
        titleLists.push(this.returnLineTitle(key));
        dateList = this.returnDataList("date", this.allList[key]);
        seriesList.push({
          name: this.returnLineTitle(key),
          type: "line",
          symbolSize: 8,
          data: this.returnDataList("num", this.allList[key]),
        });
      }
      const $BaseEcharts: any = this.$refs.BaseEcharts;
      $BaseEcharts.show(
        titleList,
        dateList,
        seriesList,
        false,
        pastDateList,
        this.returnTitle(),
        titleLists
      );
    } else {
      if (this.navList[this.navActive].key) {
        for (const key of Object.keys(this.allList)) {
          titleList.push(this.returnLineTitles(true, key));
          titleLists.push(this.returnLineTitless(true, key));
          dateList = this.returnDataList("date", this.allList[key]);
          seriesList.push({
            name: this.returnLineTitles(true, key),
            type: "line",
            symbolSize: 8,
            data: this.returnDataList("num", this.allList[key]),
          });
        }
        for (const key of Object.keys(this.allLists)) {
          titleList.push(this.returnLineTitles(false, key));
          titleLists.push(this.returnLineTitless(false, key));
          pastDateList = this.returnDataList("date", this.allLists[key]);
          seriesList.push({
            name: this.returnLineTitles(false, key),
            type: "line",
            symbolSize: 8,
            data: this.returnDataList("num", this.allLists[key]),
          });
        }
        const $BaseEcharts: any = this.$refs.BaseEcharts;
        $BaseEcharts.show(
          titleList,
          dateList,
          seriesList,
          true,
          pastDateList,
          this.returnTitle(),
          titleLists
        );
      } else {
        for (const key of Object.keys(this.allList)) {
          if (key == this.typeId) {
            titleList.push(this.returnLineTitles(true, key));
            titleLists.push(this.returnLineTitless(true, key));
            dateList = this.returnDataList("date", this.allList[key]);
            seriesList.push({
              name: this.returnLineTitles(true, key),
              type: "line",
              symbolSize: 8,
              data: this.returnDataList("num", this.allList[key]),
            });
          }
        }
        for (const key of Object.keys(this.allLists)) {
          if (key == this.typeId) {
            titleList.push(this.returnLineTitles(false, key));
            titleLists.push(this.returnLineTitless(false, key));
            pastDateList = this.returnDataList("date", this.allLists[key]);
            seriesList.push({
              name: this.returnLineTitles(false, key),
              type: "line",
              symbolSize: 8,
              data: this.returnDataList("num", this.allLists[key]),
            });
          }
        }
        const $BaseEcharts: any = this.$refs.BaseEcharts;
        $BaseEcharts.show(
          titleList,
          dateList,
          seriesList,
          true,
          pastDateList,
          this.returnTitle(),
          titleLists
        );
      }
    }
    const $BaseTable: any = this.$refs.BaseTable;
    $BaseTable.parentList(this.baseList);
  }
  public returnDataList(key, list) {
    const arr: any = [];
    if (list) {
      list.forEach((item) => {
        arr.push(key === "date" ? item.date : item.num);
      });
      return arr;
    }
    return [];
  }
  public returnTitle() {
    for (const item of this.navList) {
      if (item.id == this.navList[this.navActive].id) {
        return item.name;
      }
    }
  }
  public returnLineTitle(key) {
    for (const item of titleLineList) {
      if (item.key == key) {
        return item.name;
      }
    }
  }
  public returnLineTitles(shows, key) {
    for (const item of titleLineList) {
      if (item.key == key) {
        if (shows) {
          return `${item.name} (一) ${
            this.baseList.start_time != "" && this.baseList.end_time != ""
              ? ` (${this.baseList.start_time} - ${this.baseList.end_time})`
              : ""
          }`;
        } else {
          return `${item.name} (二) ${
            this.baseList.contrast_start_time != "" &&
            this.baseList.contrast_end_time != ""
              ? ` (${this.baseList.contrast_start_time} - ${this.baseList.contrast_end_time})`
              : ""
          }`;
        }
      }
    }
  }
  public returnLineTitless(shows, key) {
    for (const item of titleLineList) {
      if (item.key == key) {
        if (shows) {
          return `${item.name} (一)`;
        } else {
          return `${item.name} (二)`;
        }
      }
    }
  }
}
